__turbopack_context__.v({
  "asBoxes": "invKAa_asBoxes",
  "contentContainer": "invKAa_contentContainer",
  "contentContainerSwipable": "invKAa_contentContainerSwipable",
  "contentSwipable": "invKAa_contentSwipable",
  "fourColumns": "invKAa_fourColumns",
});
